var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 14.8306,
    height: 18.1667,
    viewBox: "0 0 14.8306 18.1667",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.6404 2.47457C4.30008 2.8279 2.42842 4.76078 2.147 7.24503L1.8596 9.78208C1.78819 10.4125 1.53269 11.0057 1.12688 11.4834C0.265708 12.497 0.964647 14.0833 2.27242 14.0833H12.5555C13.8633 14.0833 14.5622 12.497 13.7011 11.4834C13.2953 11.0057 13.0398 10.4125 12.9683 9.78208L12.7784 8.10561M9.91397 15.75C9.55007 16.721 8.56816 17.4167 7.41397 17.4167C6.25978 17.4167 5.27787 16.721 4.91397 15.75M14.0806 3.25C14.0806 4.63071 12.9613 5.75 11.5806 5.75C10.1999 5.75 9.08064 4.63071 9.08064 3.25C9.08064 1.86929 10.1999 0.75 11.5806 0.75C12.9613 0.75 14.0806 1.86929 14.0806 3.25Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.f422178bd8df2f3c338fda3795e8fe18.svg";
export { ForwardRef as ReactComponent };